export default function reducer(state = {
  grabacionCriterios: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_GRABACION_CRITERIOS": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}